module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('content-loader', {
    attrs: {
      "width": 300,
      "height": _vm.calculatedHeight,
      "speed": "2",
      "primaryColor": "#f3f3f3",
      "secondaryColor": "#ecebeb"
    }
  }, [_c('rect', {
    attrs: {
      "x": "8",
      "y": "18",
      "rx": "2",
      "ry": "2",
      "width": "143",
      "height": "184"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "165",
      "y": "105",
      "rx": "2",
      "ry": "2",
      "width": "143",
      "height": "96"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42a64480","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/common/content-loaders/AnalyticsChartLoader.vue
// module id = 3250
// module chunks = 3